import {
  META_GET_COUNTRIES,
  META_SET_COUNTRIES,
  GET_META_TRACKER_PLATFORMS,
  SET_META_TRACKER_PLATFORMS,
  GET_META_AD_PLATFORMS,
  SET_META_AD_PLATFORMS,
} from "./actionTypes";

export const getMetaAdPlatforms = () => ({
  type: GET_META_AD_PLATFORMS,
});

export const setMetaAdPlatforms = data => ({
  type: SET_META_AD_PLATFORMS,
  payload: data,
});

export const getMetaCountries = payload => ({
  type: META_GET_COUNTRIES,
  payload: ["", ""],
});

export const setMetaCountries = payload => ({
  type: META_SET_COUNTRIES,
  payload,
});

export const getTrackerPlatforms = () => ({
  type: GET_META_TRACKER_PLATFORMS,
});

export const setTrackerPlatforms = data => ({
  type: SET_META_TRACKER_PLATFORMS,
  payload: data,
});
